@if (authService.hasPermission(Permission.BatchesFull)) {
  <button
    mat-icon-button
    (click)="onToggleShare()"
    [matTooltip]="batch.isSharedWithSkyTeam ? 'Unshare from Sky Team' : 'Share with Sky Team'"
    matTooltipPosition="above"
    color="error"
    >
    <mat-icon>{{ batch.isSharedWithSkyTeam ? 'cloud' : 'cloud_queue' }}</mat-icon>
  </button>
}
